import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useMoreMenuCellStyles } from './moreMenuCellStyles';

export const MoreMenuCell = ({ rowType }: GridCellProps) => {
  const sxStyles = useMoreMenuCellStyles();
  const { t } = useTranslation();
  const [button, setButton] = React.useState<undefined | HTMLElement>(
    undefined,
  );

  if (rowType !== 'data') {
    return null;
  }

  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setButton(event.currentTarget);
  }

  function handleClose() {
    setButton(undefined);
  }

  return (
    <TableCell sx={sxStyles.dataCell}>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="large"
      >
        <MoreVert />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={button}
        keepMounted={true}
        open={!!button}
        onClose={handleClose}
      >
        <MenuItem>{t('addAbsence')}</MenuItem>
        <MenuItem>{t('addEquipment')}</MenuItem>
        <MenuItem>{t('addTask')}</MenuItem>
        <MenuItem>{t('addAbsence')}</MenuItem>
      </Menu>
    </TableCell>
  );
};
